import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-empty-state-loading',
  standalone: true,
  template: `
    <div class="container my-5">
      @if (isLoading) {
        <div class="loading text-center">
          <p-progressSpinner styleClass="w-4rem h-4rem"></p-progressSpinner>
        </div>
      } @else {
        <div class="empty-state">
          <div class="row p-5 w-70 justify-content-center">
            <div class="empty-icon text-muted text-center">
              <div #icon><ng-content></ng-content></div>
              <span *ngIf="!icon.innerHTML.trim()">
                <i class="pi pi-list text-2xl"></i>
              </span>
            </div>
            <div class="col-12 p-0 text-center mt-3">
              <ng-content select="[title]"></ng-content>
            </div>
            <div class="col-12 p  -0 text-center mt-3">
              <ng-content select="[text]"></ng-content>
            </div>
            <div class="col-12 p-0 text-center mt-3">
              <ng-content select="[action]"></ng-content>
            </div>
          </div>
        </div>
      }
    </div>
  `,
  imports: [CommonModule, ProgressSpinnerModule]
})
export class EmptyStateLoadingComponent {
  @Input({ required: true }) isLoading = false;
}
